/**
 * The squared switch — 46×28 at 5px, a 22px knob at 4px.
 *
 * The drawing moved to `ui/switch.tsx`, which is RNR's Switch on `@rn-primitives/switch` wearing
 * the restyle's tokens. This is the app's own calling convention over the top of it: settings rows
 * are label-left, control-right, and `value`/`onChange` is what every other control in this app
 * takes. Keeping it means the primitive arrived without a single call site moving.
 */
import { Switch as UiSwitch } from '@/components/ui/switch';

export function Switch({
  value,
  onChange,
  accessibilityLabel,
  disabled,
  className,
}: {
  value: boolean;
  onChange: (value: boolean) => void;
  accessibilityLabel: string;
  disabled?: boolean;
  className?: string;
}) {
  return (
    <UiSwitch
      checked={value}
      onCheckedChange={onChange}
      accessibilityLabel={accessibilityLabel}
      disabled={disabled}
      className={className}
    />
  );
}
